import React, { useState, useEffect, useCallback } from 'react';
import './Gallery.css';

const images = [
  { src: '/gallery/gallery1.png', alt: 'CampusXL Gallery 1' },
  { src: '/gallery/gallery2.png', alt: 'CampusXL Gallery 2' },
  { src: '/gallery/gallery3.png', alt: 'CampusXL Gallery 3' },
  { src: '/gallery/gallery4.png', alt: 'CampusXL Gallery 4' },
];

const INTERVAL = 3000;

const Gallery = () => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % images.length);
  }, []);

  const prev = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(next, INTERVAL);
    return () => clearInterval(timer);
  }, [paused, next]);

  return (
    <section className="gallery section">
      <p className="gallery-label">Gallery</p>

      <div
        className="gallery-track"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {/* Slides */}
        <div className="gallery-slides" style={{ transform: `translateX(-${current * 100}%)` }}>
          {images.map((img, i) => (
            <div className="gallery-slide" key={i}>
              <img src={img.src} alt={img.alt} className="gallery-img" />
            </div>
          ))}
        </div>

        {/* Arrows */}
        <button className="gallery-arrow gallery-arrow--prev" onClick={prev} aria-label="Previous">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button className="gallery-arrow gallery-arrow--next" onClick={next} aria-label="Next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>

        {/* Dots */}
        <div className="gallery-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`gallery-dot ${i === current ? 'gallery-dot--active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
